import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoadingService } from "./loading.service";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    counter: number;
    constructor(private _loadingService: LoadingService){
        this.counter=0;
    }
     
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        const use_loading = req.params.get('use_loading');
        if (use_loading && use_loading === 'false') {
            req.params.delete('spinner');
            // jump the interceptor
            return next.handle(req);
        }
        else
        {
            this.counter++;
            this._loadingService.show();
            return next.handle(req).pipe(
                finalize(() => {this.counter--; if(this.counter < 1) { this._loadingService.hide()}})
            )
        }
       
    }
}